/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Local_HintInputs */

const vi_einvoice_buyer_local_hint = /** @type {(inputs: Einvoice_Buyer_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần chỉnh bản nháp? Chọn Sửa thông tin hóa đơn, lưu rồi kiểm tra lại PDF.`)
};

/**

* @param {Einvoice_Buyer_Local_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_local_hint = /** @type {((inputs?: Einvoice_Buyer_Local_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Local_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_local_hint(inputs)
});